import React from "react";
import { MessageSquare, Search } from "lucide-react";
import "./Admin.css";

const MessageManager = () => {
  return (
    <div className="admin-page">
      <div className="admin-section-header" style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
          Messages / Help Desk
        </h1>
        <p style={{ color: "var(--admin-text-sub)" }}>
          Respond to attendee queries and support requests
        </p>
      </div>

      <div
        className="admin-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "350px 1fr",
          gap: "24px",
        }}
      >
        {/* Sidebar for conversations */}
        <div
          className="admin-card"
          style={{
            height: "calc(100vh - 250px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="card-header" style={{ padding: "16px" }}>
            <div style={{ position: "relative" }}>
              <Search
                size={16}
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#94a3b8",
                }}
              />
              <input
                type="text"
                placeholder="Search conversations..."
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 36px",
                  borderRadius: "8px",
                  border: "1px solid var(--admin-border)",
                  fontSize: "0.875rem",
                }}
              />
            </div>
          </div>
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "16px",
              textAlign: "center",
              color: "#94a3b8",
            }}
          >
            <p style={{ marginTop: "40px" }}>No active conversations</p>
          </div>
        </div>

        {/* Chat area */}
        <div
          className="admin-card"
          style={{
            height: "calc(100vh - 250px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f8fafc",
          }}
        >
          <div style={{ textAlign: "center", color: "#94a3b8" }}>
            <MessageSquare
              size={64}
              style={{ opacity: 0.2, marginBottom: "16px" }}
            />
            <h3>Select a conversation</h3>
            <p>Choose an attendee from the left to start chatting</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageManager;
